import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/hooks/use-session';
import { FullPageSpinner } from './full-page-spinner';

/**
 * Waits for the session check to resolve before deciding. Redirecting while it
 * is still in flight would bounce every signed-in user to the sign-in page on a
 * cold load, then bounce them back.
 */
export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isResolved } = useSession();
  const location = useLocation();

  if (!isResolved) {
    return <FullPageSpinner />;
  }

  if (!user) {
    // Carries where they were headed so sign-in can return them there.
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

/** The inverse: keeps a signed-in user out of the auth pages. */
export const PublicOnlyRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user, isResolved } = useSession();

  if (!isResolved) {
    return <FullPageSpinner />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
